// extracted by mini-css-extract-plugin
export default {"root":"external-authentication-callback_root__45bCC"};